/** Keep this in sync with android/app/build.gradle versionName and versionCode. */
export const APP_VERSION_NAME = '2.1.5'
export const APP_VERSION_CODE = 43
export const APP_BUILD_LABEL = `App ${APP_VERSION_NAME} · build ${APP_VERSION_CODE}`
